<template>
  <div>
    <Head title="Failed Deliveries" />
    <h1 class="mb-8 text-3xl font-bold">Failed Deliveries</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Attempted Delivery Date</th>
          <th class="pb-3 pt-3 px-3">Order Number</th>
          <th class="pb-3 pt-3 px-3">Customer</th>
          <th class="pb-3 pt-3 px-3">Phone</th>
          <th class="pb-3 pt-3 px-3">Alternative Phone</th>
          <th class="pb-3 pt-3 px-3">Region</th>
          <th class="pb-3 pt-3 px-3">City</th>
          <th class="pb-3 pt-3 px-3">Channel</th>
          <th class="pb-3 pt-3 px-3">Agent</th>
          <th class="pb-3 pt-3 px-3" />
        </tr>
        <tr v-for="order in orders.data" :key="order.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link
                v-if="
                    user.group_permissions.includes('update_failed_deliveries') ||
                    user.per_user_permissions.includes('update_failed_deliveries') ||
                    user.role === 'admin'
                "
                class="flex items-center px-3 py-3 focus:text-orange-500"
                :href="`/orders-failed-deliveries/${order.id}/create`"
            >
              {{ order.delivery_date }}
            </Link>
            <a v-else class="flex items-center px-3 py-3 focus:text-orange-500" href="#">{{ order.delivery_date }}</a>
          </td>
          <td class="border-t">
            <Link
                v-if="
                    user.group_permissions.includes('update_failed_deliveries') ||
                    user.per_user_permissions.includes('update_failed_deliveries') ||
                    user.role === 'admin'
                "
                class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders-failed-deliveries/${order.id}/create`"
            >
                {{ order.order_no }}
            </Link>
            <a v-else class="flex items-center px-3 py-3 focus:text-orange-500" href="#">{{ order.order_no }}</a>
          </td>
          <td class="border-t">
            <Link
                v-if="
                    user.group_permissions.includes('update_failed_deliveries') ||
                    user.per_user_permissions.includes('update_failed_deliveries') ||
                    user.role === 'admin'
                "
                class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders-failed-deliveries/${order.id}/create`"
            >
                {{ order.name }}
            </Link>
            <a v-else class="flex items-center px-3 py-3 focus:text-orange-500" href="#">{{ order.name }}</a>
          </td>
          <td class="border-t">
            <Link
                v-if="
                    user.group_permissions.includes('update_failed_deliveries') ||
                    user.per_user_permissions.includes('update_failed_deliveries') ||
                    user.role === 'admin'
                "
                class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders-failed-deliveries/${order.id}/create`"
            >
                {{ order.phone_number }}
            </Link>
            <a v-else class="flex items-center px-3 py-3 focus:text-orange-500" href="#">{{ order.phone_number }}</a>
          </td>
          <td class="border-t">
            <Link
                v-if="
                    user.group_permissions.includes('update_failed_deliveries') ||
                    user.per_user_permissions.includes('update_failed_deliveries') ||
                    user.role === 'admin'
                "
                class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders-failed-deliveries/${order.id}/create`"
            >
                {{ order.alternative_phone_number ?? '-' }}
            </Link>
            <a v-else class="flex items-center px-3 py-3 focus:text-orange-500" href="#">{{ order.alternative_phone_number ?? '-' }}</a>
          </td>
          <td class="border-t">
            <Link
                v-if="
                    user.group_permissions.includes('update_failed_deliveries') ||
                    user.per_user_permissions.includes('update_failed_deliveries') ||
                    user.role === 'admin'
                "
                class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders-failed-deliveries/${order.id}/create`"
            >
                {{ order.region }}
            </Link>
            <a v-else class="flex items-center px-3 py-3 focus:text-orange-500" href="#">{{ order.region }}</a>
          </td>
          <td class="border-t">
            <Link
                v-if="
                    user.group_permissions.includes('update_failed_deliveries') ||
                    user.per_user_permissions.includes('update_failed_deliveries') ||
                    user.role === 'admin'
                "
                class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders-failed-deliveries/${order.id}/create`"
            >
                {{ order.town }}
            </Link>
            <a v-else class="flex items-center px-3 py-3 focus:text-orange-500" href="#">{{ order.town }}</a>
          </td>
          <td class="border-t">
            <Link
                v-if="
                    user.group_permissions.includes('update_failed_deliveries') ||
                    user.per_user_permissions.includes('update_failed_deliveries') ||
                    user.role === 'admin'
                "
                class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders-failed-deliveries/${order.id}/create`"
            >
                {{ order.channel }}
            </Link>
            <a v-else class="flex items-center px-3 py-3 focus:text-orange-500" href="#">{{ order.channel }}</a>
          </td>
          <td class="border-t">
            <Link
                v-if="
                    user.group_permissions.includes('update_failed_deliveries') ||
                    user.per_user_permissions.includes('update_failed_deliveries') ||
                    user.role === 'admin'
                "
                class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/orders-failed-deliveries/${order.id}/create`"
            >
                {{ order.agent }}
            </Link>
            <a v-else class="flex items-center px-3 py-3 focus:text-orange-500" href="#">{{ order.agent }}</a>
          </td>
          <td class="w-px border-t">
            <Link
                v-if="
                    user.group_permissions.includes('update_failed_deliveries') ||
                    user.per_user_permissions.includes('update_failed_deliveries') ||
                    user.role === 'admin'
                "
                class="flex items-center px-3" tabindex="-1" :href="`/orders-failed-deliveries/${order.id}/create`"
            >
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
            <a v-else class="flex items-center px-3 py-3 focus:text-orange-500" href="#" title="Update Order"></a>
          </td>
        </tr>
        <tr v-if="orders.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="4">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="orders.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import Multiselect from '@vueform/multiselect'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton' 

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Pagination,
    Multiselect,
    TextInput,
    LoadingButton
  },
  layout: Layout,
  props: {
    filters: Object,
    orders: Object,
    errors: Object,
    cancelationReasons: Array,
    rescheduleReasons: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
      formData: this.$inertia.form({
        action_option: null,
        reason: null,
        reschedule_date: null,
        order_id: null
      }),
      isOpen: false,
      isDetailsOpen: false,
      orderObj: [],
      reasonOptions: [],
      details: [],
      failOptions: [
        {
            label: 'Reschedule',
            value: 'Reschedule'
        },
        {
            label: 'Cancel',
            value: 'Cancel'
        }
      ],
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/orders-failed-deliveries', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  computed: {
    user() {
        return this.$inertia.page.props.auth.user;
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    openDetailsModal(order) {
      this.isDetailsOpen = true;
      this.isOpen = false
      this.orderObj = order,
      this.details = order.details
      this.formData.order_id = this.orderObj.id
      this.formData.delivery_date = this.orderObj.delivery_date[0].date
    },
    closeDetailsModal() {
      this.isDetailsOpen = false;
      this.details = []
    },
    openModal(data, string) {
      this.formData.action_option = string
      if(string === "Reschedule") {
        this.reasonOptions = this.cancelationReasons
      }

      if(string === "Cancel") {
        this.reasonOptions = this.cancelationReasons
      }
      this.isOpen = true;
      this.orderObj = data
      this.formData.order_id = this.orderObj.id
      this.formData.delivery_date = this.orderObj.delivery_date[0].date
    },
    closeModal() {
      this.isOpen = false;
    },
    onSelectedFailureOption(option, id) {
        this.reasonOptions = []
        if(option === "Reschedule") {
            this.reasonOptions = this.cancelationReasons
        }

        if(option === "Cancel") {
            this.reasonOptions = this.cancelationReasons
        }
    },
    updateOrder() {
      this.formData._method = 'post'
      this.formData.post(`/orders-failed-deliveries`, {
        onSuccess: () => {
            this.formData.reset()
            this.isOpen = false
            this.isDetailsOpen = false;
        },
        onError: (error) => {
        },
      })
    },
  },

}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>
